import AttentionIcon from '@raison/static/icons/error-warning-line.svg';
import {doNothing} from '@raison/toolbox';
import {RsnCheckbox, RsnDialog, RsnIconWidget} from '@raison/ui-kit';
import React, {useState} from 'react';
import InlineSvg from 'react-inlinesvg';
import {TransactionsHistory} from '~/entities/transactions-history';
import {IconProp} from '~/library/ui-kit/src/Components/shared/props';
import {FilterPopupLayout} from '../FilterPopupLayout';
import BottomButtons from './BottomButtons/BottomButtons';
import {isFilterUnchanged} from './shared';

type Options = {
    label: string;
    key: TransactionsHistory.MoreFilter;
    logo: IconProp;
};

const optionsList: Options[] = [
    {
        label: 'Low-value crypto transaction',
        key: 'show_low_value_transactions',
        logo: {
            element: (
                <div className={'center flex size-9 items-center justify-center rounded-full bg-neutral-20'}>
                    <InlineSvg className={'size-[18px] text-neutral-100'} src={AttentionIcon} />
                </div>
            ),
        },
    },
];

export const MoreFiltersPopup = () => {
    const {onClose: close = doNothing} = RsnDialog.useControls();
    const [{more: appliedFilter}, {apply: applyFilters}] = TransactionsHistory.useFilters();

    const [checkedBoxes, setSelected] = useState(new Set(appliedFilter));

    const nothingChanged = isFilterUnchanged(appliedFilter, checkedBoxes);
    const nothingSelected = checkedBoxes.size === 0;

    const onChange = (itemName: TransactionsHistory.MoreFilter, checked: boolean) => {
        setSelected(prevState => {
            if (checked) {
                return new Set(prevState).add(itemName);
            } else {
                return new Set(Array.from(prevState).filter(key => key !== itemName));
            }
        });
    };

    const onApply = () => {
        applyFilters({more: Array.from(checkedBoxes)});
        close();
    };

    const onClear = () => {
        setSelected(new Set());
    };

    return (
        <FilterPopupLayout
            title='More'
            padding={'none'}
            footer={
                <BottomButtons
                    isApplyDisabled={nothingChanged}
                    isClearHidden={nothingSelected}
                    applyCallback={onApply}
                    clearCallback={onClear}
                />
            }
        >
            <div className='flex flex-col'>
                {optionsList.map(({label, key, logo}) => (
                    <RsnIconWidget.Lg
                        key={label}
                        icon={logo}
                        as='label'
                        className={'p-4'}
                        addon={
                            <RsnCheckbox
                                onChange={e => onChange(key, e.target.checked)}
                                checked={checkedBoxes.has(key)}
                            />
                        }
                    >
                        <RsnIconWidget.Text children={label} />
                    </RsnIconWidget.Lg>
                ))}
            </div>
        </FilterPopupLayout>
    );
};
